import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import styles from './index.module.scss.js';

const GamePreview = ({
  href,
  image,
  index,
  title,
  onClick,
  className,
  ...props
}) => /* @__PURE__ */ React.createElement(
  Link,
  {
    ...props,
    to: href,
    key: index,
    className: cx(styles.box, className),
    onClick
  },
  /* @__PURE__ */ React.createElement("div", { className: cx(styles.card, "game-preview") }, /* @__PURE__ */ React.createElement("div", { className: styles.card__media }, /* @__PURE__ */ React.createElement("img", { src: image, alt: title })))
);
GamePreview.displayName = "GamePreview";

export { GamePreview };
//# sourceMappingURL=index.js.map
